import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-surface-light dark:bg-surface-dark text-text-secondary-light dark:text-text-secondary-dark py-12 transition-colors duration-300">
      <div className="container mx-auto px-8">
        <div className="text-center pt-8">
          <p className="text-lg">
            © 2024 322 Project Team. All rights reserved.
          </p>
          <div className="mt-4 flex justify-center space-x-6">
            <a href="#" className="hover:text-primary-light dark:hover:text-primary-dark transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-primary-light dark:hover:text-primary-dark transition-colors">
              Terms of Service
            </a>
            <a href="#" className="hover:text-primary-light dark:hover:text-primary-dark transition-colors">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;